
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/participation/partners",
      function () {
        return require("private-next-pages/participation/partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/participation/partners"])
      });
    }
  